import { applicationConfig } from '../applicationConfig'
export class home {
  appTitle: string;
  shouldAggregate: string;
  contractSummary: any[];
  rawData: any[][];
  aggrObj: any;
  aggVal: any;

  constructor(appTitle: string) {
    this.appTitle = appTitle;
    this.contractSummary = [];
    this.rawData = [];
    this.aggrObj = null;
    this.aggVal = null;
  }

  aggregationImpl(
    obj: any,
    shouldAggregate: string,
    genericService: any,
    aggregationService: any,
    isAggregationBucket: string,
    analyticSrvc: any
  ) {
    let appObj = { aggVal: null, contracts: [] };
    let totalBUs = JSON.parse(sessionStorage.getItem("userBUs"));
    let totalBUct = totalBUs && totalBUs.content ? totalBUs.content.length : 0;
    if (this.appTitle === "home") {
      if (shouldAggregate === "Y") {
        if (
          obj["contractSummaryResponse"] &&
          obj["contractSummaryResponse"].contractSummary
        ) {
          genericService.updateResArr(obj["contractSummaryResponse"]);
          appObj = obj;
        }
      } else if (isAggregationBucket === "true") {
        this.aggrObj = genericService.aggData;
        genericService.resArrObs$.subscribe(resArr => {
          if (resArr.responseCode !== "200") {
            aggregationService.setContractError(true);
          } else {
            //  let contractsArray = genericService.retContractSummary(resArr);
            let contractsArray = resArr && resArr["contractSummary"] ? resArr["contractSummary"] : [];
            /** logic to handle to seperate out prudential accounts and remobve external account and fetch new batch of external accounts when reconnect/add account happens**/
            if (contractsArray.length > 0) {
              if (/retirement/i.test(contractsArray[0].lineOfBusiness)) {
                contractsArray.sort((a, b) => a.productType && b.productType && a.productType.trim() > b.productType.trim() ? 1 : -1);
              }
              if (/external account/i.test(contractsArray[0].accountType)) {
                let newarr = [];
                this.contractSummary.forEach((contract, index) => {
                  if (contract && !contract.accountType) {
                    newarr.push(contract);
                  }
                });
                this.contractSummary = newarr;
              }
              if (/sia/i.test(contractsArray[0].productTypeCode)) {
                let newarr = [];
                this.contractSummary.forEach((contract) => {
                  if (contract && contract.productTypeCode !== "SIA")
                    newarr.push(contract);
                });
                this.contractSummary = newarr;
              }
            }else {
              let newarr = [];
              this.contractSummary.forEach((contract, index) => {
                if (contract && !contract.accountType) {
                  newarr.push(contract);
                }
              });
              this.contractSummary = newarr;
            }

            this.contractSummary = this.contractSummary.concat(contractsArray);
            this.rawData.push(contractsArray);
            analyticSrvc.setAnalytics(this.rawData);
          }

          if (genericService.resArr.length === totalBUct) {
            this.aggVal = aggregationService.getAggAmt(this.contractSummary, this.aggrObj[0]);
            let arrFinal = [];
            let aggrObj = this.aggrObj[0];
            for (let i = 0; i < this.aggVal.length; i++) {
              arrFinal.push({
                key: aggrObj[i].container,
                value: this.aggVal[i]
              });
            }
            appObj.aggVal = arrFinal;
            appObj["contracts"].push(this.contractSummary);
            genericService.updateAggDataArr(appObj);
            aggregationService.emitAggDone();
            analyticSrvc.notifyAnalytics();
          } else {
            let arrFinal = [],
              aggrObj = this.aggrObj[0];
            for (let i = 0; i < aggrObj.length; i++) {
              arrFinal.push({
                key: aggrObj[i].container,
                value: "0"
              });
            }

            appObj.aggVal = arrFinal;
          //  appObj["contracts"].push(this.contractSummary);
        //    genericService.updateAggDataArr(appObj);
          }
          appObj["aggVal"].forEach(element => {
            let elementKey = element.key.toLowerCase();
            switch (elementKey) {
              case "asset":
                element.key = element.key + "s";
                break;
              default:
                break;
            }
          });
        });
      } else {
        appObj = obj;
      }
      return appObj;
    }
  }
}
